
import { AdminDashboard } from "@/components/admin/AdminDashboard";
import { AdminRouteGuard } from "@/components/admin/AdminRouteGuard";

export default function AdminDashboardPage() {
  return (
    <AdminRouteGuard requiredRole="superadmin">
      <AdminDashboard />
    </AdminRouteGuard>
  );
}
